import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import {
  IconButton,
  Step,
  StepLabel,
  TableCell,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CandidateSupportIco from "../../../../assets/icons/CandidateSupportIco";
import DeleteIco from "../../../../assets/icons/DeleteIco";
import PageStepperDefaultIco from "../../../../assets/icons/PageStepperDefaultIco";
import ReportBugIco from "../../../../assets/icons/ReportBugIco";
import StepperActiveIco from "../../../../assets/icons/StepperActiveIco";
import StepperInprogressIco from "../../../../assets/icons/StepperInprogressIco";
import SupportIco from "../../../../assets/icons/SupportIco";
import SnackBar from "../../../../component/SnackBar";
import {
  trackFeatureFailure,
  trackFeatureUsage,
} from "../../../../modules/mixpanel/mixpanel";
import {
  ChatBotCall,
  ChatBotGetCall,
  SupportCall,
  SupportGetCall,
} from "../../../../redux/action/ChatBot";
import { FeedBackButton } from "../../../../redux/action/Feedback";
import { CreateJobDelete, CreateJobList } from "../../../../redux/action/Job";
import { MinimizeIcon } from "../../../../redux/action/Login";
import { UploadJob } from "../../../../redux/action/QuickMatch";
import CommonTable from "../../../candidates/Table";
import ChatBotLabelText from "../../../chat-bot/ChatBotLabelText";
import SideBarChatBot from "../../../chat-bot/SIdeBarChatBot";
import { CustomDiv } from "../../../chat-bot/style";
import {
  CommonGrid2,
  DotColor,
  StatusChange,
} from "../../../common-components/StyledComponents";
import { StepperStyle } from "../../../matches/quick-match/style";
import InputJobData from "../components/InputJobData";
import ReviewJobPost from "../components/ReviewJobPost";
import SkillDeleteDialog from "../../../common-components/DeleteDialog";
import { TeamGetCall } from "../../../../redux/action/UserManagement";
import { handleDataTime } from "../../../common-components/JobFunction";

const EnrichJob = () => {
  const [enrichFile, setEnrichFile] = useState([]);
  const [uploadJobData, setUploadJobData] = useState({});
  const [inputJobDrag, setInputJobDrag] = useState(false);
  const localStorageData = JSON.parse(localStorage.getItem("credential"));
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const theme = useTheme();
  const [deleteTableRow, setDeleteTableRow] = useState({
    open: false,
    loading: false,
    content: "",
    id: "",
  });
  const [createJobList, setCreateJobList] = useState({
    data: [],
    currentPage: 1,
    totalPage: "",
    loading: true,
  });
  const limit = 5;
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(useLocation().search);
  const valueStatus = query.get("value");
  const headerData = [
    { name: "Req ID", direction: "asc", sort: false, minWidth: "120px" },
    { name: "Title", direction: "asc", sort: false },
    { name: "Status", direction: "asc", sort: false },
    {
      name: "Compensation (Hourly / Annual)",
      direction: "asc",
      sort: false,
      minWidth: "200px",
    },
    { name: "Client", direction: "asc", sort: false },
    { name: "Created", direction: "asc", sort: false },
    {},
  ];
  const [chatBotData, setChatBotData] = useState({
    message: [
      { sender: "bot", text: "Hi, I am Hailey. How can I assist you today?" },
    ],
    value: "",
    loader: false,
    pageLoader: false,
    arrow: true,
    bubble: [],
    bubbleCondition: false,
    selectedValue: "Support",
    expandDrawer: false,
  });
  const [isBottomVisible, setIsBottomVisible] = useState(true);
  const [tabData, setTabData] = useState([
    {
      label: "Input Job Data",
      status: "In Progress",
    },
    {
      label: "Scoring",
      status: "Pending",
    },
    {
      label: "Review Job Post",
      status: "Pending",
    },
  ]);
  const [value, setValue] = useState(0);
  const buttonSupport = [
    ...(value === 2
      ? [
          {
            name: "Job",
            icon: <CandidateSupportIco />,
          },
          {
            name: "Support",
            icon: <SupportIco />,
          },
        ]
      : [
          {
            name: "Support",
            icon: <SupportIco />,
          },
        ]),
    {
      name: "Report Bug",
      icon: <ReportBugIco />,
    },
  ];

  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const [buttonLoading, setButtonLoading] = useState(false);
  const allowedTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];
  const [userData, setUserData] = useState({
    account_executive: { username: "", id: "" },
    job_owner: { username: "", id: "" },
    user_list: [],
    date_time: null,
  });

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleInputJobDragOver = (event) => {
    event.preventDefault();
    setInputJobDrag(true);
  };

  const handleInputJobDragLeave = () => {
    setInputJobDrag(false);
  };

  const handleInputJobDrop = (event) => {
    event.preventDefault();
    setInputJobDrag(false);
    const droppedFiles = Array.from(event.dataTransfer.files);
    commonFileValidationCheck(
      droppedFiles,
      allowedTypes,
      setEnrichFile,
      enrichFile
    );
  };

  const uploadFile = async (getName, setCandidateFiles, payload) => {
    setTabData((prev) =>
      prev.map((tab, index) =>
        index < 1
          ? { ...tab, status: "Completed" }
          : index === 1
          ? { ...tab, status: "In Progress" }
          : tab
      )
    );
    setValue(1);

    setButtonLoading(true);
    setCandidateFiles((prevFiles) =>
      prevFiles.map((f) => ({
        ...f,
        delete: false,
      }))
    );
    if (
      localStorageData?.organization === "Demo" &&
      localStorageData?.role === "Demo"
    ) {
      const interval = setInterval(() => {
        setCandidateFiles((prevFiles) =>
          prevFiles.map((f) => {
            const updatedProgress = f.progress + 10;
            const isComplete = updatedProgress >= 100;

            if (isComplete) {
              clearInterval(interval);

              setTimeout(() => {
                setUploadJobData(localStorageData?.demo_config?.demo_job);

                setTabData((prev) =>
                  prev.map((tab, index) =>
                    index <= 2 ? { ...tab, status: "Completed" } : tab
                  )
                );

                setValue(2);
                setSnackbarState({
                  open: true,
                  message: "Update Successfully",
                  severity: "success",
                });
              }, 500);

              return { ...f, progress: 100, buffer: 100 };
            }

            return {
              ...f,
              progress: updatedProgress,
              buffer: updatedProgress,
              visible: false,
              delete: false,
            };
          })
        );
      }, 300);

      setTimeout(() => clearInterval(interval), 4000);
    } else {
      const formData = new FormData();
      enrichFile.forEach((fileObj, index) => {
        formData.append("files", fileObj.file);
      });
      formData.append("account_executive", userData?.account_executive?.id);
      formData.append("job_owner", userData?.job_owner?.id);
      formData.append(
        "submission_deadline",
        userData?.date_time
          ? new Date(
              userData.date_time.format("YYYY-MM-DDTHH:mm:ss")
            ).toISOString()
          : ""
      );
      try {
        const response = await UploadJob(formData, getName, "Draft");

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";

        while (true) {
          const { value, done } = await reader.read();
          if (done) break;
          const chunk = decoder.decode(value, { stream: true });
          buffer += chunk;
          let boundaryIndex;
          while ((boundaryIndex = buffer.indexOf("}\n")) !== -1) {
            const jsonString = buffer.slice(0, boundaryIndex + 1);
            buffer = buffer.slice(boundaryIndex + 1);
            const jsonResponse = JSON.parse(jsonString);
            try {
              await processJsonResponse(
                jsonResponse,
                getName,
                setCandidateFiles
              );
            } catch (e) {
              setTabData((prev) =>
                prev.map((tab, index) =>
                  index === 0
                    ? { ...tab, status: "Inprogress" }
                    : index === 1
                    ? { ...tab, status: "Pending" }
                    : tab
                )
              );
              setValue(0);
              setCandidateFiles((prevFiles) =>
                prevFiles.map((f) => ({
                  ...f,
                  visible: true,
                  delete: true,
                  message: jsonResponse.message,
                }))
              );

              setSnackbarState({
                open: true,
                message: "Error parsing JSON",
                severity: "error",
              });
            }
          }
        }

        if (buffer) {
          const jsonResponse = JSON.parse(buffer);
          try {
            await processJsonResponse(jsonResponse, getName, setCandidateFiles);
          } catch (e) {
            setTabData((prev) =>
              prev.map((tab, index) =>
                index === 0
                  ? { ...tab, status: "Inprogress" }
                  : index === 1
                  ? { ...tab, status: "Pending" }
                  : tab
              )
            );
            setValue(0);

            setCandidateFiles((prevFiles) =>
              prevFiles.map((f) => ({
                ...f,
                visible: true,
                delete: true,
                message: jsonResponse.message,
              }))
            );

            setSnackbarState({
              open: true,
              message: "Error parsing final JSON chunk",
              severity: "error",
            });
          }
        }

        setButtonLoading(false);
      } catch (error) {
        // Track API failure
        trackFeatureFailure("Enrich Job File Upload", error, {
          file_count: enrichFile.length,
          file_types: enrichFile.map((f) => f.type),
        });

        setTabData((prev) =>
          prev.map((tab, index) =>
            index === 0
              ? { ...tab, status: "Inprogress" }
              : index === 1
              ? { ...tab, status: "Pending" }
              : tab
          )
        );
        setValue(0);

        setCandidateFiles((prevFiles) =>
          prevFiles.map((f) => ({
            ...f,
            visible: true,
            delete: true,
            message: "Error during the request",
          }))
        );

        setSnackbarState({
          open: true,
          message: "Error during the request",
          severity: "error",
        });

        setButtonLoading(false);
      }
    }
  };

  const processJsonResponse = (jsonResponse, getName, setCandidateFiles) => {
    const { success, data, message } = jsonResponse;
    // setUploadJobData(jsonResponse);
    if (success && data?.percent !== undefined) {
      setCandidateFiles((prevFiles) =>
        prevFiles.map((f) => ({
          ...f,
          progress: data.percent,
          buffer: data.percent,
          visible: false,
          delete: false,
          progress_message: data.progress_message,
        }))
      );
    } else if (data?.id) {
      setUploadJobData(data?.id);

      // Track successful file upload
      trackFeatureUsage("Enrich Job File Upload", {
        job_id: data.id,
        file_count: enrichFile.length,
        file_types: enrichFile.map((f) => f.type),
      });

      setSnackbarState({
        open: true,
        message: message,
        severity: "success",
      });

      setTabData((prev) =>
        prev.map((tab, index) =>
          index <= 1
            ? { ...tab, status: "Completed" }
            : { ...tab, status: "In Progress" }
        )
      );
      setValue(2);
    } else if (!success) {
      // Track failed file upload
      trackFeatureFailure("Enrich Job File Upload", message, {
        file_count: enrichFile.length,
        file_types: enrichFile.map((f) => f.type),
      });

      setTabData((prev) =>
        prev.map((tab, index) =>
          index === 0
            ? { ...tab, status: "Inprogress" }
            : index === 1
            ? { ...tab, status: "Pending" }
            : tab
        )
      );
      setValue(0);

      setCandidateFiles((prevFiles) =>
        prevFiles.map((f) => ({
          ...f,
          visible: true,
          delete: true,
          message: message,
        }))
      );
    }
  };

  const handleInputJobDeleteFile = (index) => {
    setEnrichFile((prevFiles) => {
      if (prevFiles.length === 1) {
        setTabData((prev) =>
          prev.map((tab, index) =>
            index === 0
              ? { ...tab, status: "In Progress" }
              : { ...tab, status: "Pending" }
          )
        );
        setValue(0);
      }
      return prevFiles.filter((_, i) => i !== index);
    });
  };

  const commonFileValidationCheck = (
    commonFiles,
    allowedTypes,
    setCommonFiles,
    existingFiles
  ) => {
    const validFiles = [];
    const invalidFiles = [];

    commonFiles.forEach((file) => {
      if (allowedTypes.includes(file.type)) {
        validFiles.push({
          file,
          name: file.name,
          size: `${(file.size / 1024).toFixed(1)} KB`,
          type: file.type,
          progress: 0,
          buffer: 0,
          visible: false,
          delete: true,
          message: "",
        });
        setTabData((prev) =>
          prev.map((tab, index) =>
            index === 0 ? { ...tab, status: "Completed" } : tab
          )
        );
        setValue(1);
      } else {
        invalidFiles.push(file.name);
      }
    });

    const mergedFiles = [
      ...existingFiles,
      ...validFiles.filter(
        (newFile) =>
          !existingFiles.some(
            (existingFile) => existingFile.name === newFile.name
          )
      ),
    ];
    setCommonFiles(mergedFiles);

    if (invalidFiles.length > 0) {
      setSnackbarState({
        open: true,
        message: `Unsupported file types: ${invalidFiles.join(", ")}`,
        severity: "error",
      });
    }
  };

  const handleFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    commonFileValidationCheck(
      selectedFiles,
      allowedTypes,
      setEnrichFile,
      enrichFile
    );
  };

  const handleButtonCommon = (data) => {
    if (data === 1) {
      trackFeatureUsage("Enrich Job Import Button", {
        file_count: enrichFile.length,
        file_types: enrichFile.map((f) => f.type),
      });
      uploadFile("NextUpload", setEnrichFile);
    }
  };

  const handlePageChange = (page) => {
    setCreateJobList((prev) => ({
      ...prev,
      currentPage: page,
    }));
    fetchJobsList(limit, (page - 1) * limit);
  };

  const fetchJobsList = async (limit, offset) => {
    setCreateJobList((prev) => ({
      ...prev,
      loading: true,
    }));
    try {
      let params = {
        limit: limit,
        offset: offset,
        status: "Draft",
        jd_type: "Enrich",
      };
      const response = await CreateJobList(params);
      const data = response.data;
      setCreateJobList((prev) => ({
        ...prev,
        data: data?.results || [],
        totalPage: data?.total_pages,
        loading: false,
      }));
    } catch (err) {
      setCreateJobList((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  const fetchUsersList = async () => {
    try {
      setUserData((prev) => ({
        ...prev,
        loading: true,
      }));
      const usersList = await TeamGetCall();
      setUserData((prev) => ({
        ...prev,
        user_list: usersList?.data || [],
        loading: false,
      }));
    } catch (error) {
      setUserData((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
    }
  };

  useEffect(() => {
    if (value === 0) {
      fetchJobsList(limit, (createJobList.currentPage - 1) * limit);
      fetchUsersList();
    }
  }, [value]);

  useEffect(() => {
    if (valueStatus === null) {
      setTabData((prev) =>
        prev.map((tab, index) =>
          index === 0
            ? { ...tab, status: "In Progress" }
            : { ...tab, status: "Pending" }
        )
      );
      setEnrichFile([]);
      setValue(0);
    }
  }, [location]);

  const handleIconClick = (row) => {
    setChatBotData((prev) => ({
      ...prev,
      selectedValue: "Job",
    }));
    setTabData((prev) =>
      prev.map((tab, index) =>
        index <= 1
          ? { ...tab, status: "Completed" }
          : { ...tab, status: "In Progress" }
      )
    );
    setUploadJobData(row?.id);
    setTimeout(() => {
      navigate(`/enrich-job?value=${2}`);
      setValue(2);
    }, 0);
  };

  const handleTableBodyData = (row, index) => {
    if (!row) return null;

    const handleDeleteClick = (e, row) => {
      e.stopPropagation();
      setDeleteTableRow((prev) => ({
        ...prev,
        open: true,
        content: row.job_title,
        id: row.id,
      }));
    };
    return (
      <>
        <TableCell>{row.req_id || "-"}</TableCell>
        <TableCell>{row.job_title || "-"}</TableCell>

        <TableCell>
          <StatusChange>
            <DotColor
              color={
                row.status === "Active"
                  ? "green"
                  : row.status === "Hold"
                  ? "orange"
                  : "#667085"
              }
            />
            {row.status || "-"}
          </StatusChange>
        </TableCell>
        <TableCell>{row.pay_rate || "-"}</TableCell>
        <TableCell>{row.client || "-"}</TableCell>
        <TableCell>
          {row.created_at ? new Date(row.created_at).toLocaleDateString() : "-"}
        </TableCell>
        <TableCell>
          <CommonGrid2 alignItems={"center"} gap={"0.8rem"} display={"flex"}>
            <VisibilityOutlinedIcon
              onClick={() => (buttonLoading ? {} : handleIconClick(row))}
              style={{
                cursor: buttonLoading ? "auto" : "pointer",
                fontSize: "21px",
                opacity: buttonLoading ? 0.4 : 1,
              }}
            />
            <IconButton
              onClick={(e) => handleDeleteClick(e, row)}
              disabled={buttonLoading}
              style={{ opacity: buttonLoading ? 0.4 : 1 }}
            >
              <DeleteIco strokeWidth={2} />
            </IconButton>
          </CommonGrid2>
        </TableCell>
      </>
    );
  };

  const handleDeleteTableClose = () => {
    setDeleteTableRow({
      open: false,
      loading: false,
      content: "",
      id: "",
    });
  };

  const handleDeleteRow = async () => {
    try {
      setDeleteTableRow((prev) => ({
        ...prev,
        loading: true,
      }));

      let data = await CreateJobDelete(deleteTableRow.id);
      setCreateJobList((prev) => ({
        ...prev,
        currentPage:
          createJobList.currentPage === 1
            ? 1
            : createJobList.data?.length === 1
            ? createJobList.currentPage - 1
            : createJobList.currentPage,
      }));
      let page =
        createJobList.currentPage === 1
          ? 1
          : createJobList.data?.length === 1
          ? createJobList.currentPage - 1
          : createJobList.currentPage;

      fetchJobsList(limit, (page - 1) * limit);

      setSnackbarState({
        open: true,
        message: data?.message,
        severity: "success",
      });
      handleDeleteTableClose();
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setDeleteTableRow((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  const QontoStepIcon = (props) => {
    const { active, completed } = props;

    if (completed) {
      return <StepperActiveIco size={"28"} />;
    }
    if (active) {
      return <StepperInprogressIco size={"28"} />;
    } else return <PageStepperDefaultIco size={"28"} />;
  };

  useEffect(() => {
    setChatBotData((prev) => ({
      ...prev,
      selectedValue: value === 2 ? "Job" : "Support",
    }));

    if (
      (value === 0 || value === 1) &&
      chatBotData.selectedValue === "Support"
    ) {
      handleSupportCall();
    }
    if (value === 2) {
      handleChatBotCandidateCall();
    }
  }, [value]);

  const handleSupportCall = async () => {
    setChatBotData((prev) => ({
      ...prev,
      pageLoader: true,
      message: [
        { sender: "bot", text: "Hi, I am Hailey. How can I assist you today?" },
      ],
    }));
    try {
      const data = await SupportGetCall(localStorageData?.user_id);
      const messages = [];
      data?.history?.forEach((entry) => {
        if (entry.user) {
          const userMessage = {
            sender: "user",
            text: entry.user,
          };
          messages.push(userMessage);
        }
        if (entry.assistant) {
          const botMessage = {
            sender: "bot",
            text: entry.assistant,
          };
          messages.push(botMessage);
        }
      });

      setChatBotData((prev) => ({
        ...prev,
        message: [prev.message[0], ...messages],
        bubble: data?.data?.bubble_questions,
        pageLoader: false,
      }));
      setIsBottomVisible(false);
    } catch (error) {
      setChatBotData((prev) => ({
        ...prev,
        pageLoader: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.message,
      });
    }
  };

  const handleButtonSupport = (name) => {
    setChatBotData((prev) => ({
      ...prev,
      selectedValue: name === "Report Bug" ? prev.selectedValue : name,
    }));
    if (name === "Report Bug") {
      dispatch(FeedBackButton(true));
    } else if (name === "Support") {
      handleSupportCall();
    } else if (name === "Job") {
      handleChatBotCandidateCall();
    }
  };

  const handleToggleDrawer = () => {
    if (!open) {
      if (value === 2) {
        handleChatBotCandidateCall();
      } else {
        handleSupportCall();
      }
    }
    setChatBotData((prev) => ({
      ...prev,
      selectedValue: value === 2 ? "Job" : "Support",
      expandDrawer: false,
    }));
    setOpen((prev) => {
      const newState = !prev;
      dispatch(MinimizeIcon(prev, newState));
      return newState;
    });
  };

  const handleChatBotCandidateCall = async () => {
    setChatBotData((prev) => ({
      ...prev,
      pageLoader: true,
      message: [
        { sender: "bot", text: "Hi, I am Hailey. How can I assist you today?" },
      ],
    }));
    try {
      const data = await ChatBotGetCall(uploadJobData);
      const messages = [];
      data?.data?.history?.forEach((entry) => {
        if (entry.user) {
          const userMessage = {
            sender: "user",
            text: entry.user,
          };
          messages.push(userMessage);
        }
        if (entry.assistant) {
          const botMessage = {
            sender: "bot",
            text: entry.assistant,
          };
          messages.push(botMessage);
        }
      });

      setChatBotData((prev) => ({
        ...prev,
        message: [prev.message[0], ...messages],
        bubble: data?.data?.bubble_questions,
        pageLoader: false,
      }));
      setIsBottomVisible(false);
    } catch (error) {
      setChatBotData((prev) => ({
        ...prev,
        pageLoader: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.message,
      });
    }
  };

  const handleSendMessage = async () => {
    if (!chatBotData.value.trim()) return;
    let payload;
    if (chatBotData.selectedValue === "Job") {
      payload = {
        query: chatBotData.value,
        filter_criteria: {
          type: "match_data",
          job_data_id: uploadJobData,
        },
      };
    } else {
      payload = {
        query: chatBotData.value,
        filter_criteria: {
          type: "user_manuals",
          user_id: localStorageData?.user_id,
        },
      };
    }

    setChatBotData((prev) => ({
      ...prev,
      message: [...prev.message, { sender: "user", text: chatBotData.value }],

      loader: true,
      value: "",
    }));

    try {
      let data;
      if (chatBotData.selectedValue === "Job") {
        data = await dispatch(ChatBotCall(payload));
      } else {
        data = await SupportCall(payload);
      }
      const botResponse = {
        sender: "bot",
        text: data?.data?.response,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
      }));
    } catch (error) {
      const botResponse = {
        sender: "error",
        text: error?.data?.message,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
        value: "",
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.message,
      });
    }
  };

  const handleChatBotChange = (event) => {
    setChatBotData((prev) => ({
      ...prev,
      value: event.target.value,
    }));
    if (event.key === "Enter") {
      handleSendMessage();
    }
  };

  const handleUpArrow = (condition) => {
    setChatBotData((prev) => ({
      ...prev,
      arrow: condition === "up" ? false : true,
    }));
  };

  const handleStepCompleted = () => {
    setTabData((prev) =>
      prev.map((tab, index) =>
        index <= 2 ? { ...tab, status: "Completed" } : { ...tab }
      )
    );
  };

  const handleExpandDrawer = () => {
    setChatBotData((prev) => ({
      ...prev,
      expandDrawer: !prev.expandDrawer,
    }));
  };

  const handleMenuItem = (value, name) => {
    setUserData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <CustomDiv
      background="#F6F8FB"
      height={"100vh"}
      overflowY="auto"
      display="flex"
    >
      <CommonGrid2
        width={
          open
            ? `calc(100% - ${chatBotData.expandDrawer ? "450px" : "350px"})`
            : "100%"
        }
        border={"1px solid rgba(0, 0, 0, 0.12)"}
        background="#fff"
        borderRadius={"10px"}
        height={"fit-content"}
        padding={"1rem"}
        margin={"1.35rem 1rem 1.35rem 1.35rem"}
        position={"relative"}
        sx={{
          transition: theme.transitions.create(["width"], {
            duration: theme.transitions.duration.short,
            easing: theme.transitions.easing.easeInOut,
          }),
        }}
      >
        <Typography variant="h2">Enrich Job</Typography>
        <StepperStyle
          activeStep={value}
          margin={value === 2 && "1rem  0px 2rem"}
        >
          {tabData.map((step, index) => (
            <Step
              key={step.label}
              style={{
                padding:
                  index === 2
                    ? "0px 0px 0px 1.2rem"
                    : index === 0
                    ? "0px 1.2rem 0px 0px"
                    : "0px 1.2rem",
              }}
            >
              <StepLabel StepIconComponent={QontoStepIcon}>
                <CommonGrid2
                  display="flex"
                  flexDirection="column"
                  gap="5px"
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Typography variant="span" color="#344054" fontWeight={600}>
                    {step.label}
                  </Typography>

                  <Typography
                    variant="span"
                    color={
                      step.status === "Completed"
                        ? "#17B26A"
                        : step.status === "In Progress"
                        ? "#7F56D9"
                        : "#5B738B"
                    }
                  >
                    {step.status}
                  </Typography>
                </CommonGrid2>
              </StepLabel>
            </Step>
          ))}
        </StepperStyle>
        {(value === 0 || value === 1) && (
          <>
            <InputJobData
              inputJdView={1}
              handleButtonCommon={handleButtonCommon}
              handleFileUpload={handleFileUpload}
              enrichFile={enrichFile}
              buttonLoading={buttonLoading}
              handleInputJobDeleteFile={handleInputJobDeleteFile}
              handleInputJobDragOver={handleInputJobDragOver}
              handleInputJobDragLeave={handleInputJobDragLeave}
              handleInputJobDrop={handleInputJobDrop}
              inputJobDrag={inputJobDrag}
              userData={userData}
              handleMenuItem={handleMenuItem}
              handleDataTime={(newValue) =>
                handleDataTime(newValue, setUserData)
              }
            />
            <CommonTable
              data={createJobList.data}
              columns={headerData}
              onSortChange={(col) => console.log("Sort by", col)}
              handleTableBodyData={handleTableBodyData}
              paginationProps={{
                count: createJobList.totalPage,
                page: createJobList.currentPage,
                onPageChange: (page) => handlePageChange(page),
              }}
              withPagination={true}
              loading={createJobList.loading}
              customStyle={{
                "& .MuiTableRow-root": {
                  cursor: buttonLoading ? "auto" : "pointer",
                },
                "& .MuiTableRow-head": {
                  cursor: "auto",
                },
              }}
              handleRowClick={buttonLoading ? {} : handleIconClick}
            />
          </>
        )}
        {value === 2 && (
          <ReviewJobPost
            createId={uploadJobData}
            handleStepCompleted={handleStepCompleted}
          />
        )}
      </CommonGrid2>
      <CommonGrid2
        sx={{
          transition: theme.transitions.create(["width"], {
            duration: theme.transitions.duration.short,
            easing: theme.transitions.easing.easeInOut,
          }),
        }}
        width={open ? (chatBotData.expandDrawer ? "450px" : "350px") : "0px"}
        border={"1px solid rgba(0, 0, 0, 0.12)"}
        background="#fff"
        top={"0px"}
        position={"sticky"}
        right={"0"}
        height={"100%"}
        overflowY={"auto"}
        scrollStyle
        scrollBar="5px"
      >
        <CommonGrid2
          padding={"0rem 1rem 1rem"}
          height={"100%"}
          justifyContent={"space-between"}
          display={"flex"}
          flexDirection={"column"}
        >
          <SideBarChatBot
            handleToggleDrawer={handleToggleDrawer}
            jobId={uploadJobData}
            // height={minimizeScreen}
            chatBotData={chatBotData}
            // handleChatBotFetchData={handleChatBotFetchData}
            handleSendMessage={handleSendMessage}
            handleChatBotChange={handleChatBotChange}
            isBottomVisible={isBottomVisible}
            setIsBottomVisible={setIsBottomVisible}
            handleUpArrow={handleUpArrow}
            userName={localStorageData?.username}
            buttonSupport={buttonSupport}
            handleButtonSupport={handleButtonSupport}
            handleExpandDrawer={handleExpandDrawer}
          />
        </CommonGrid2>
      </CommonGrid2>
      <SkillDeleteDialog
        deleteDialog={deleteTableRow.open}
        handleDeleteDialogClose={handleDeleteTableClose}
        handleDeleteSkill={handleDeleteRow}
        buttonLoading={deleteTableRow.loading}
        title={"Delete Job"}
        content={deleteTableRow.content}
      />
      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
      {!open && (
        <ChatBotLabelText
          title={value === 2 ? "My name is Hailey. Ask me about this Job" : ""}
          chatBotData={chatBotData}
          handleToggleDrawer={handleToggleDrawer}
        />
      )}
    </CustomDiv>
  );
};
export default EnrichJob;
